import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nModule } from '@recruitee/i18n';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DatePickerComponent,
  DropdownComponent,
  GroupComponent,
  IconComponent,
  InputComponent,
  OverlayOriginDirective,
  TimePickerDropdownComponent,
} from '@recruitee/user-interface';

import { ScheduleDateDropdownComponent } from './schedule-date-picker/schedule-date-dropdown/schedule-date-dropdown.component';
import { ScheduleDatePickerComponent } from './schedule-date-picker/schedule-date-picker.component';
import { ScheduleDurationPickerComponent } from './schedule-duration-picker/schedule-duration-picker.component';
import { ScheduleTimePickerComponent } from './schedule-time-picker/schedule-time-picker.component';

@NgModule({
  imports: [
    ButtonComponent,
    CommonModule,
    ConnectedOverlayDirective,
    DatePickerComponent,
    DropdownComponent,
    GroupComponent,
    I18nModule,
    IconComponent,
    InputComponent,
    OverlayOriginDirective,
    ReactiveFormsModule,
    TimePickerDropdownComponent,
    ScheduleDatePickerComponent,
    ScheduleDateDropdownComponent,
    ScheduleDurationPickerComponent,
    ScheduleTimePickerComponent,
  ],
  exports: [
    ScheduleDatePickerComponent,
    ScheduleDurationPickerComponent,
    ScheduleTimePickerComponent,
    ScheduleDateDropdownComponent,
  ],
})
export class InterviewFindTimeUiModule {}
